import { mainApi } from "services/main";
import {
  Filter,
  CreateFilterRequest,
  UpdateFilterRequest,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    listFilters: builder.query<
      Filter[],
      { teamName: string; category: string }
    >({
      query: ({ teamName, category }) => ({
        url: "/filters",
        params: { teamName, category },
      }),
      transformResponse: (response: { filters: Filter[] }) => response.filters,
      providesTags: ["Filters"],
    }),
    createFilter: builder.mutation<{ filterId: string }, CreateFilterRequest>({
      query: (body) => ({ url: "/filters", method: "POST", body }),
      invalidatesTags: ["Filters"],
    }),
    updateFilter: builder.mutation<{ filter: Filter }, UpdateFilterRequest>({
      query: ({ filterId, ...body }) => ({
        url: `/filters/${filterId}`,
        method: "PUT",
        body: { filterId, ...body },
      }),
      invalidatesTags: ["Filters"],
    }),
    deleteFilter: builder.mutation<void, string>({
      query: (filterId) => ({
        url: `/filters/${filterId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Filters"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListFiltersQuery,
  useCreateFilterMutation,
  useUpdateFilterMutation,
  useDeleteFilterMutation,
} = extendedApi;
